import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.homebutler.us';

const SEO = ({ title, description, schemaData, path, image }) => {
    const canonicalUrl = path ? `${SITE_URL}${path}` : SITE_URL;
    const ogImage = image || `${SITE_URL}/logo512.png`;

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={canonicalUrl} />

            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:image" content={ogImage} />

            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:url" content={canonicalUrl} />
            <meta name="twitter:image" content={ogImage} />

            {schemaData && (
                <script type="application/ld+json">
                    {JSON.stringify(schemaData)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;
